/*
 * A Google Maps typescript model for use in Typescript components.
 */
export const MELBOURNE_CBD = { lat: -37.8236195, lng: 144.9416169 };
export const CENTRE_OF_AUSTRALIA = { lat: -25.274398, lng: 133.775136 };
